import { KIOSK_SLOT_EVENTS } from 'constants/InterventionConstants';
import { createReducer, createEntityAdapter } from 'utils/ReduxUtils';

import { isInterventionWithEvents } from './utils';

const interventionEventAdapter = createEntityAdapter({ selectId: ({ id }) => id });

/**
 * @param {import('modules/interventions/types/projections/detailed-intervention-event').DetailedInterventionEvent} event
 * @param {import('modules/interventions/types/projections/detailed-intervention').DetailedIntervention} intervention
 * @returns {import('modules/interventions/types/projections/detailed-intervention-event').DetailedInterventionEvent}
 */
const eventCleaner = ({ links, ...event }, intervention) => {
  if (KIOSK_SLOT_EVENTS.includes(event.event)) {
    const { selfServiceId } = event;
    const slot = intervention.selfServices?.find(({ id }) => id === selfServiceId)?.slot?.kiosk?.name;
    return { ...event, detail: slot };
  }
  return event;
};

export default createReducer(interventionEventAdapter.getInitialState(), {}, [
  {
    matcher: isInterventionWithEvents,
    reducer: (state, { payload: intervention }) =>
      interventionEventAdapter.updateMany(
        state,
        intervention.events.map(event => eventCleaner(event, intervention))
      ),
  },
]);
